import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import { useGetUserProfileQuery } from './store/api/userApiSlice';
import { setCredentials } from './store/slices/authSlice';

// Pages
import Home from './pages/Home';
import ContactUS from './pages/ContactUS';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import CollegeFinder from './pages/CollegeFinder.jsx';
import Counsellor from './pages/Counsellor.jsx';
import CounselorProfile from './pages/CounselorProfile.jsx';
import PrivacyPolicySection from './components/PrivacyPolicy/PrivacyPolicySection.jsx';
import JobsPage from './pages/JobsPage.jsx';
import JobDetailsPage from './pages/JobDetailsPage.jsx';

import EducationLoan from './pages/EducationLoan.jsx';

// Auth Pages
import Login from './pages/Login';
import Signup from './pages/signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import EventPage from './pages/EventPage.jsx';

// Component to sync user profile from backend on app load
function UserProfileSync() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const { data: userProfile } = useGetUserProfileQuery(undefined, {
    skip: !token, // Only fetch if logged in
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (userProfile && token) {
      console.log('[Debug] Syncing user profile from backend:', userProfile);
      dispatch(setCredentials({ userInfo: userProfile, token }));
    }
  }, [userProfile, token, dispatch]);

  return null; // This component renders nothing
}

function App() {
  return (
    <Router>
      <UserProfileSync />
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/contactus" element={<ContactUS />} />
          <Route path="/events" element={<EventPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:id" element={<BlogPost />} />
          <Route path="/college-finder" element={<CollegeFinder />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/:id" element={<JobDetailsPage />} />
          <Route path="/counsellor" element={<Counsellor />} />
          <Route path="/counsellor-profile/:id" element={<CounselorProfile />} />
          <Route path="/privacy-policy" element={<PrivacyPolicySection />} />
          <Route path="/education-loan" element={<EducationLoan />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<Profile />} />
         
        </Routes>
      </div>
    </Router>
  );
}

export default App;

